import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { absurd, pipe } from 'fp-ts/function';
import { useContext } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import { SocialAuthButton } from '../../social-auth-button';
import { removeFailure, removeSuccess } from './alerts';
import { connectStatus } from './common';
import { useRevokeSocialAuth } from './mutations';
import VisibilityButton from './visibility-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DisconnectButton = function DisconnectButton(_ref) {
  var mutationStatus = _ref.mutationStatus,
      revokeSocialAuth = _ref.revokeSocialAuth,
      socialId = _ref.socialId;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "DisconnectButton",
    "data-source-file": "action-buttons.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(LoadingButton, {
        color: "secondary",
        variant: "contained",
        loadingIndicator: t('Disconnecting...'),
        loading: DE.isPending(mutationStatus) || DE.isRefresh(mutationStatus),
        disabled: DE.isPending(mutationStatus) || DE.isRefresh(mutationStatus),
        onClick: function onClick() {
          return revokeSocialAuth({
            variables: {
              input: {
                id: socialId
              }
            }
          });
        },
        children: t('Disconnect')
      });
    }
  });
};

var ConnectButton = function ConnectButton(_ref2) {
  var social = _ref2.social,
      profileId = _ref2.profileId;
  var status = connectStatus(social);

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var socialId = social.id;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useRevokeSocialAuth = useRevokeSocialAuth({
    onCompleted: E.match(function () {
      return showAlert(removeFailure(t));
    }, function (_ref3) {
      var __typename = _ref3.revokeSocialAuthentication.__typename;
      return __typename === 'RevokeSocialAuthenticationResult' ? showAlert(removeSuccess(t)) : showAlert(removeFailure(t));
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(function (e) {
        return console.error(e);
      }, function (_ref4) {
        var revokeSocialAuthentication = _ref4.revokeSocialAuthentication;
        return revokeSocialAuthentication.__typename === 'RevokeSocialAuthenticationResult' && cache.modify({
          id: cache.identify(makeReference("Profile:".concat(profileId))),
          fields: {
            socialAccounts: A.map(function (cachedSocial) {
              return cachedSocial.id === revokeSocialAuthentication.socialAccount.id ? _objectSpread(_objectSpread({}, cachedSocial), revokeSocialAuthentication.socialAccount) : cachedSocial;
            })
          }
        });
      }));
    }
  }),
      _useRevokeSocialAuth2 = _slicedToArray(_useRevokeSocialAuth, 2),
      revokeSocialAuth = _useRevokeSocialAuth2[0],
      mutationStatus = _useRevokeSocialAuth2[1];

  if (status === 'Connected' || status === 'Expired') {
    return /*#__PURE__*/_jsx(DisconnectButton, {
      mutationStatus: mutationStatus,
      revokeSocialAuth: revokeSocialAuth,
      socialId: socialId
    });
  }

  if (status === 'Disconnected') return /*#__PURE__*/_jsx(SocialAuthButton, {
    authUrl: social.authUrl,
    text: t('Connect')
  });
  return absurd(status);
};

var ActionButtons = function ActionButtons(_ref5) {
  var social = _ref5.social,
      profileId = _ref5.profileId,
      inColumnView = _ref5.inColumnView;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      ml: inColumnView ? 0 : 'auto',
      mt: inColumnView ? 1 : 0
    },
    "data-element": "Box",
    "data-component": "ActionButtons",
    "data-source-file": "action-buttons.tsx",
    children: [social.connected ? /*#__PURE__*/_jsx(VisibilityButton, {
      social: social
    }) : null, /*#__PURE__*/_jsx(ConnectButton, {
      social: social,
      profileId: profileId,
      "data-element": "ConnectButton",
      "data-component": "ActionButtons",
      "data-source-file": "action-buttons.tsx"
    })]
  });
};

export default ActionButtons;